import {
  MEDICAL_CCS1_COPY,
  MEDICAL_CCS2_COPY,
  MEDICAL_CLINICAL_COPY_FIELDS
} from "constants/clinicalCopy";
import get from "lodash/get";

const UNAVAILABLE = "[unavailable]";
const CCS1 = "CCS1";

/*
 * Given a clinical ID, get either the title, short name, description copy,
 * or tooltip copy from the constants file.
 */
export function getMedicalClinicalCopy(
  id,
  copyType = MEDICAL_CLINICAL_COPY_FIELDS.TITLE,
  ccsType = CCS1
) {
  const copyObject = ccsType === CCS1 ? MEDICAL_CCS1_COPY : MEDICAL_CCS2_COPY;

  const copy = get(copyObject[id], copyType, UNAVAILABLE);

  if (copy === UNAVAILABLE) {
    // try the other copyObject
    let newCopyObject = ccsType === CCS1 ? MEDICAL_CCS2_COPY : MEDICAL_CCS1_COPY;
    return get(newCopyObject[id], copyType, UNAVAILABLE);
  }

  return copy;
}
